// Signature.tsx
import styled, { keyframes, css } from "styled-components";

const fillit = (fillColor: string) => keyframes`
  50% {
    stroke-dashoffset: 765;
  }
  90% {
    fill: transparent;
  }
  100% {
    stroke-dashoffset: 0;
    fill: ${fillColor};
  }
`;

const fillit1 = (fillColor: string) => keyframes`
  0% {
    stroke-dasharray: 1800;
    stroke-dashoffset: 1800;
    fill: transparent;
    opacity: 1;
  }



  60% {
    stroke-dashoffset: 300;
    opacity: 1;
  }

   80% {
      stroke-dashoffset: 0;
      fill: ${fillColor};
   }

   100% {
      stroke-dashoffset: 0;
      fill: ${fillColor};
      opacity: 1;
   }
`;

const SignatureBody = styled.div`
   background-color: transparent;
   box-sizing: border-box;
`;

const SignatureContainer = styled.div`
   width: 100%;
   text-align: center;
`;

const SignatureMain = styled.div`
   width: 200px;
`;

const SignatureSVG = styled.svg<{ strokeColor: string; fillColor: string }>`
   .primaryPath {
      fill: transparent;
      stroke-width: 1;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-dasharray: 154;
      stroke-dashoffset: 154;
      ${({ fillColor }) => css`
         animation: ${fillit1(fillColor)} 6.5s linear forwards;
      `}
      stroke: ${({ strokeColor }) => strokeColor};
   }

   .secondaryPath {
      fill: transparent;
      stroke-width: 0.3;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-dasharray: 765;
      stroke-dashoffset: 765;
      ${({ fillColor }) => css`
         animation: ${fillit(fillColor)} 2.5s linear 2s forwards;
      `}
      stroke: ${({ strokeColor }) => strokeColor};
   }
`;

const SignatureText = styled.text<{ strokeColor: string }>`
   font-family: "Funnel Sans", sans-serif;
   fill: ${({ strokeColor }) => strokeColor};
`;

function Signature({ dark }: { dark: boolean }) {
   const strokeColor = dark ? "#FFFFFF" : "#000000";
   const fillColor = dark ? "#FFFFFF" : "#000000";

   return (
      <SignatureBody>
         <SignatureContainer>
            <SignatureMain>
               <SignatureSVG
                  strokeColor={strokeColor}
                  fillColor={fillColor}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 400 118"
               >
                  <title>Sevan Evans</title>
                  <path
                     className="primaryPath"
                     d="M 74.00,1.00
           C 74.00,1.00 76.00,1.00 76.00,1.00
             77.36,6.17 74.91,21.26 71.87,25.71
             70.85,27.19 70.38,27.18 69.00,28.00
             69.00,28.00 70.00,15.00 70.00,15.00
             66.09,24.16 50.58,37.03 42.00,42.44
             42.00,42.44 34.00,47.00 34.00,47.00
             46.78,47.00 69.52,50.86 81.00,56.32
             93.60,62.32 95.95,70.26 87.00,81.00
             102.26,81.00 137.05,81.79 151.00,84.67
             157.12,85.93 168.73,87.52 171.00,94.00
             171.00,94.00 151.00,88.43 151.00,88.43
             129.40,84.78 112.60,84.96 91.00,85.00
             78.58,85.02 75.69,91.36 65.00,96.84
             54.68,102.13 41.57,104.86 30.00,105.00
             22.95,105.08 15.91,104.88 9.00,103.33
             6.45,102.76 2.69,101.81 1.88,98.91
             1.07,95.97 3.90,94.17 6.02,92.88
             10.73,90.00 16.73,87.99 22.00,86.35
             31.67,83.33 46.80,82.02 57.00,81.68
             57.00,81.68 68.00,81.68 68.00,81.68
             68.00,81.68 75.00,81.68 75.00,81.68
             81.53,81.13 90.31,75.40 88.16,68.01
             86.99,64.00 81.60,60.83 78.00,59.24
             66.52,54.17 40.68,50.02 28.00,50.00
             22.82,49.99 18.03,50.43 13.00,49.00
             13.00,49.00 13.00,47.00 13.00,47.00
             19.99,45.55 22.46,46.63 30.00,43.77
             44.17,38.40 60.28,24.71 68.45,12.00
             70.68,8.53 72.25,4.72 74.00,1.00 Z
           M 72.00,14.00
           C 72.00,14.00 71.00,14.00 71.00,14.00
             71.00,14.00 72.00,15.00 72.00,15.00
             72.00,15.00 72.00,14.00 72.00,14.00 Z
           M 171.00,68.00
           C 172.96,62.37 175.87,61.02 179.99,56.96
             179.99,56.96 196.01,40.96 196.01,40.96
             199.61,37.41 201.12,34.56 206.00,33.00
             205.08,38.55 199.96,42.13 196.04,45.83
             196.04,45.83 176.00,66.00 176.00,66.00
             176.00,66.00 195.00,66.00 195.00,66.00
             197.53,66.03 204.40,65.90 203.72,70.03
             203.26,72.75 199.23,75.18 197.00,76.37
             189.39,80.40 183.84,81.40 176.00,87.00
             176.00,87.00 207.00,83.00 207.00,83.00
             207.00,78.62 206.07,75.63 210.00,73.00
             210.00,73.00 211.00,88.00 211.00,88.00
             211.00,88.00 219.91,79.28 219.91,79.28
             224.63,74.83 230.95,67.90 235.11,78.04
             235.64,79.33 235.77,80.65 236.00,82.00
             236.00,82.00 243.00,80.00 243.00,80.00
             243.00,80.00 242.00,75.00 242.00,75.00
             247.97,74.40 250.00,74.66 253.53,80.04
             254.95,82.20 257.14,87.96 260.06,87.96
             262.79,87.96 265.63,83.03 267.00,81.00
             267.00,81.00 271.00,83.00 271.00,83.00
             275.10,78.12 281.19,71.85 288.00,73.00
             288.00,73.00 288.00,75.00 288.00,75.00
             288.00,75.00 276.00,83.00 276.00,83.00
             282.64,83.02 294.25,84.70 285.85,93.91
             284.42,95.49 282.69,96.72 281.00,98.00
             281.00,98.00 321.00,99.00 321.00,99.00
             321.00,99.00 321.00,101.00 321.00,101.00
             321.00,101.00 295.00,102.00 295.00,102.00
             295.00,102.00 267.00,102.00 267.00,102.00
             267.00,102.00 267.00,100.00 267.00,100.00
             275.27,95.91 279.89,95.64 286.00,88.18
             279.90,85.72 278.05,85.56 272.00,88.18
             268.69,89.89 261.54,94.09 258.04,92.70
             254.69,91.35 250.02,81.69 247.00,78.00
             247.91,84.01 248.66,94.68 241.00,96.00
             239.86,93.99 234.30,86.25 232.08,86.62
             229.66,87.02 229.32,90.24 224.00,93.00
             224.00,93.00 226.00,85.00 226.00,85.00
             226.00,85.00 223.00,82.00 223.00,82.00
             223.00,82.00 228.00,82.00 228.00,82.00
             228.00,82.00 228.00,77.00 228.00,77.00
             219.14,83.84 209.77,98.21 207.00,86.00
             201.11,87.80 186.29,90.31 180.00,90.83
             177.21,91.06 170.60,90.75 172.40,86.14
             173.33,83.76 177.79,81.10 180.00,79.90
             186.53,76.34 194.66,74.33 200.00,69.00
             200.00,69.00 171.00,68.00 171.00,68.00 Z
           M 151.00,76.00
           C 151.00,76.00 159.00,74.00 159.00,74.00
             157.93,80.39 153.10,81.98 151.00,76.00 Z
           M 76.00,85.00
           C 59.65,85.00 37.49,85.16 22.00,90.16
             16.19,92.04 8.37,93.47 5.00,99.00
             25.12,102.66 47.77,102.80 66.00,92.38
             70.40,89.86 72.65,88.92 76.00,85.00 Z
           M 241.00,85.00
           C 241.00,85.00 238.00,85.00 238.00,85.00
             238.00,85.00 241.00,90.00 241.00,90.00
             241.00,90.00 241.00,85.00 241.00,85.00 Z
           M 281.00,98.00
           C 281.00,98.00 280.00,98.00 280.00,98.00
             280.00,98.00 281.00,99.00 281.00,99.00
             281.00,99.00 281.00,98.00 281.00,98.00 Z"
                     transform="translate(15 10)"
                  />
               </SignatureSVG>
            </SignatureMain>
         </SignatureContainer>
      </SignatureBody>
   );
}

export default Signature;
